import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import { GiftRegistrantEntity } from "../entities/GiftRegistrantEntity";
import { GiftRegistryItemEntity } from "../entities/GiftRegistryItemEntity";

export type GiftCartState = {
    registryId: number | null;
    registrant: GiftRegistrantEntity | null;
    items: GiftRegistryItemEntity[];
};

function createInitialState(): GiftCartState {
    return {
        registryId: null,
        registrant: null,
        items: [],
    };
}

@singleton()
@StoreConfig({ name: "GiftCartStore" })
class GiftCartStore extends BaseStore<GiftCartState> {
    constructor() {
        super(createInitialState());
    }
}

export default GiftCartStore;
